var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMhoAdd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Comps",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Super-Admin-Dashboard-Final",
    transform: "translate(-1244.000000, -198.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(1244.000000, 198.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    stroke: "#5C76A7",
    cx: 5.5,
    cy: 9,
    r: 5
  }), /*#__PURE__*/React.createElement("text", {
    id: "+",
    fontFamily: "Lato-Bold, Lato",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#5C76A7"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2,
    y: 12
  }, "+"))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMhoAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mho-add.f00df134590f5929c1e68281d440caee.svg";